export default {
  en: {
    'components.file-list.no-data': 'No files have been uploaded yet.',
  },
};
